// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Therefore we will not fear, though the earth be moved,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and though the mountains tremble in the heart of the sea;<br> </p> </div></div>";
// Exports
module.exports = code;